import React from "react";
import { Card, CardContent } from "@/components/ui/card";

export default function SeoGrowthFaq({ faqs }) {
  return (
    <section className="space-y-4">
      <h2 className="font-heading text-3xl font-black">Frequently asked questions</h2>
      <div className="grid gap-4 md:grid-cols-2">
        {faqs.map((faq) => (
          <Card key={faq.q}>
            <CardContent className="p-6">
              <h3 className="font-bold text-foreground">{faq.q}</h3>
              <p className="mt-2 text-sm leading-6 text-muted-foreground">{faq.a}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
}